






















import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "client-header": () => import("@/skeleton/client/clientHeader.vue"),
    "client-footer": () => import("@/skeleton/client/clientFooter.vue")
  }
})
export default class ClientContainer extends Vue {}
